export default __webpack_public_path__ + "static/media/40.3b3a5c21.jpg";